import { Injectable } from '@angular/core';
import { URLSearchParams, Http } from '@angular/http';
import {Observable} from  "rxjs/Observable";
import {HttpService} from "./http-service";
import {LoadingService} from "./loading-service";
import { AuthStore } from '../stores/auth-store';
import 'rxjs/add/operator/map';

/*
  Generated class for the RegistService provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RegistService extends HttpService {

  constructor(public http: Http
    , protected loadingService:LoadingService
    , protected authStore: AuthStore
  ) {
    super(http, loadingService, authStore);
  }

  /**
   * 記録登録処理
   */
  sendMail(data:object): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/regist/sendMail");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * 電話番号認証リクエストを送る
   */
  sendAuthenticationLinkToPhone(phoneNumber: string): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/Regist/sendAuthenticationLinkToPhone");
    var options = super.buildParam(userParam);

    return super.post(options, { phoneNumber: phoneNumber });
  }

  /**
   * 電話番号認証を行う
   */
  authenticationPhone(phoneNumber: string, token:string): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/Regist/authenticationPhone");
    var options = super.buildParam(userParam);

    return super.post(options, { phoneNumber: phoneNumber, token: token });
  }

  /**
   * Eメール認証リクエストを送る
   */
  sendAuthenticationLinkToEmail(data: object): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/Regist/sendAuthenticationLinkToEmailUpdatePassword");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * Eメール認証を行う
   */
  authenticationEmail(email: string, token: string, id:string): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/Regist/authenticationEmail");
    var options = super.buildParam(userParam);

    return super.post(options, { email: email, token: token, id:id });
  }
}



// WEBPACK FOOTER //
// ./src/providers/regist-service.ts